import { Form, Row, Col, Button } from "react-bootstrap"
import { useSelector, useDispatch } from "react-redux"
import { SmallMainFourButtons } from "./helpers"
import { useEffect } from "react"
import { getWarehouseStatus } from "redux/warehouse/warehouseSlice"

const Filters = () => {
  const dispatch = useDispatch()

  const filters = useSelector((state) => state.warehouse.filters)

  const handleFilterChange = (newFilters) => {
    dispatch({
      type: "warehouse/setFilters",
      payload: newFilters,
    })
  }

  const display = useSelector((state) => state.warehouse.display)
  const warehouse = useSelector((state) => state.warehouse.warehouse)

  const { loading, warehouseStatus, error } = useSelector((state) => state.warehouse)

  const latePickupStyle = {
    fontWeight: warehouseStatus?.late_pickups > 0 ? "bold" : "",
    color: warehouseStatus?.late_pickups > 0 ? "red" : "black",
  }
  const discrepancyStyle = {
    fontWeight: warehouseStatus?.discrepancies > 0 ? "bold" : "",
    color: warehouseStatus?.discrepancies > 0 ? "red" : "black",
  }

  const report = `${warehouseStatus?.scanned_count}/${warehouseStatus?.on_dock} loads audited by ${warehouseStatus?.last_audit?.auditor} on ${warehouseStatus?.last_audit?.date}`

  return (
    <>
      <div className="row">
        <div className="col-lg-4 col-md-8 pr-0">
          <h4 className="warehouse-main-header-title">
            {display} Orders - <span className={`${warehouse}-text`}>{warehouse}</span>
          </h4>
          <div>
            <div className="col-auto" style={latePickupStyle}>Late for pickup: {warehouseStatus?.late_pickups}</div>
            <div className="col-auto">Inventory: {report}</div>
            <div className="col-auto" style={discrepancyStyle}>Discrepancy: {warehouseStatus?.discrepancies}</div>
          </div>
        </div>
        <div className="col">
          <Form.Group>
            <Form.Label className='mb-0'>Search</Form.Label>
            <Form.Control
              className=""
              type='text'
              value={filters.searchText}
              onChange={(e) =>
                handleFilterChange({ "searchText": e.target.value })
              }
            ></Form.Control>
            <Form.Label className='mb-0'>Order Type</Form.Label>
            <Form.Control
              as='select'
              placeholder={'Select Order Type'}
              value={filters.orderType}
              onChange={(e) =>
                handleFilterChange({ "orderType": e.target.value })
              }
            >
              <option value="all">All</option>
              <option value="bus">Bus</option>
              <option value="partial">Partial</option>
              <option value="dock">Dock</option>
              <option value="direct">Direct</option>
            </Form.Control>
          </Form.Group>
        </div>
      </div>
      <br />
    </>
  )
}

export default Filters
